<template lang="pug">
 vm-prompt(vm-size="small" :vm-buttons-hidden="true" @vm-cancel="close" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')"  :vm-active="isModalSessionOrderVisible" :vm-title="$t('purchase_orders.exit')")
    vm-row(class="purchase-exit" vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12)
      vm-col(class="purchase-exit__text" vm-justify="center", vm-align="center", vm-w=12)
        span {{ $t('front.end_session_2') }}
      vm-row(class="purchase-exit__footer" vm-type="flex" vm-w="12")
        vm-col(vm-type="flex" vm-align="center", vm-w=6)
            vm-button(class="button_white" @click="exit()") {{ $t('requisitions_mailboxes.edit_later')  }}
        vm-col(vm-type="flex" vm-justify="right", vm-align="center", vm-w=6)
            vm-button(@click="continueEditing()") {{ $t('requisitions_mailboxes.end_order')  }}
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('PurchaseOrders')
export default {
  name: 'ModalSessionOrder',
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    inView: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
  }),
  computed: {
    ...mapGetters(['isModalSessionOrderVisible'])
  },
  async created () {
  },
  methods: {
    ...mapActions([
      'setModalSessionOrderVisible',
      'setModalOrderVisible'
    ]),
    continueEditing () {
      if (this.inView) {
        this.$emit('store')
        this.setModalSessionOrderVisible(false)
      } else {
        this.setModalSessionOrderVisible(false).then(() => {
          this.$router.push({ path: `/create-purcharse-orders/${this.$route.params.id}` })
        })
      }
    },
    exit () {
      this.setModalSessionOrderVisible(false).then(() => {
        this.$router.push({ name: 'requisitions-mailboxes' })
      })
    },
    close () {
      this.setModalSessionOrderVisible(false)
    }
  }
}
</script>
<style lang="scss">
.con-title-after {
  color: black !important;
}
.purchase-exit {
  &__text {
    font-weight: 400;
    font-size: 18px;
    text-align: center;
  }
  &__footer {
    margin: 10px;
    .vm-button {
      border-radius: 15px;
    }
    .button_white {
      background-color: white !important;
      color: black !important;
      display: flex;
      border: 1px solid black;
      margin: 5px;
    }
  }
}
</style>
